import { Injectable } from '@angular/core';
import { EnvService, HttpWrapperService } from '.';
import { Observable } from 'rxjs';

export interface IpAddress {
  ip: string;
}

@Injectable({ providedIn: 'root' })
export class IpAddressService {
  constructor(private envService: EnvService, private httpClient: HttpWrapperService) {}

  getIpAddress(): Observable<IpAddress> {
    const url = this.envService.ipAddress.url + '?format=json';
    return this.httpClient.get<IpAddress>(url);
  }
}
